import React, {useState, useEffect, useRef, useCallback} from "react";
import {Card, CardBody, Container, Row} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import {Button, DatePicker, Pagination, Table} from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import Skeleton from "react-loading-skeleton";
import Select from "react-select";
import "react-loading-skeleton/dist/skeleton.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/Import.css";
import {Modal} from "bootstrap";
import LoadingScreen from "../util/LoadingScreen";
import HospitalSearch from "../hospital/HospitalSearch";
import AuthService from "../login/AuthService";
import dayjs from "dayjs";
import CustomPagination from "../util/CustomPagination";

const {RangePicker} = DatePicker;

const statusOptions = [
    {value: null, label: 'Selecionar'},
    {value: 'Pending', label: 'Pendente'},
    {value: 'Processed', label: 'Processando'},
    {value: 'Completed', label: 'Completo'},
];

const Import = () => {
    document.title = "Importação | Plantão Rápido";

    const hospitalSearchRef = useRef(null);
    const [loadingImportationTypes, setLoadingImportationTypes] = useState(false);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [importationTypes, setImportationTypes] = useState([]);
    const userData = AuthService.getUserData();
    const [companyOptions, setCompanyOptions] = useState([]);
    const [arrayBatches, setArrayBatches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [searchFilters, setSearchFilters] = useState({
        dateRange: [],
        datestart: null,
        dateend: null,
        status: "",
        importationType: null
    });

    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [typeDoc, setTypeDoc] = useState({formFile: null, importationType: null});
    const [templateLink, setTemplateLink] = useState(null);
    const [visibleCompany, setVisibleCompany] = useState(false);
    const [visibleHospital, setVisibleHospital] = useState(false);
    const [visibleDepartment, setVisibleDepartment] = useState(false);
    const [fileAccept, setFileAccept] = useState("");

    const fileInputRef = useRef(null);

    const handleModalOpen = () => {

        if (hospitalSearchRef.current) {
            hospitalSearchRef.current.clearHospital();
        }

        setTypeDoc(prev => ({
            ...prev,
            formFile: null,
            department: null,
            hospital: null
        }));

        const modal = new Modal(document.getElementById('newImportModal'));
        modal.show();
    };

    const handleModalClose = () => {
        const modal = Modal.getInstance(document.getElementById('newImportModal'));
        modal.hide();
    };


    const fetchImportationTypes = async () => {
        try {

            setLoadingImportationTypes(true); // Iniciar carregamento
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}import/list-type`);

            const {data} = ApiService.handleApiResponse(response);


            setImportationTypes(data.map(type => ({
                value: type.id,
                label: type.name,
                template: type.template,
                visible_company: type.visible_company,
                visible_hospital: type.visible_hospital,
                visible_department: type.visible_department,
                accept: type.accept,
            })));
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingImportationTypes(false); // Finalizar carregamento
        }
    };


    const downloadTemplate = async (templateId) => {
        try {
            // Enviar a solicitação com o tipo de resposta configurado como blob
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}import/download-template`, {id: templateId}, true, 'blob');

            const blob = new Blob([response], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            const downloadUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `template_${new Date().toISOString().split('T')[0]}.xlsx`;
            link.click();
            URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            // Exibir mensagem de erro
            ApiService.handleApiError(error);
        }
    };


    const fetchImportBatches = async (page) => {
        setLoading(true);
        try {
            const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}import/list`, {
                pagination: pagination.pageSize,
                page: page,
                datestart: searchFilters.datestart,
                dateend: searchFilters.dateend,
                status: searchFilters?.status?.value || null,
                import_types_id: searchFilters?.importationType?.value || null
            }, true);

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setArrayBatches(data || []);
            setPagination(pagInfo || {current: 0, pageSize: 10, total: 0});

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        const userData = AuthService.getUserData();
        if (userData?.companies) {
            const options = userData.companies?.map(company => ({
                value: company.id,
                label: company.name,
            }));
            setCompanyOptions(options);
        }
        fetchImportationTypes();
        fetchDepartment();
        fetchImportBatches();
    }, []);

    const handleSearchFiltersChange = (field, value) => {
        setSearchFilters(prev => ({
            ...prev,
            [field]: value  // ✔ Correção: usa o parâmetro correto
        }));
    };


    const handleSearch = (page) => {
        setSearchFilters(pendingFilters);
        setPagination({...pagination, current: 1});
    };

    const handleClearFilters = () => {
        setSearchFilters({
            dateRange: [],
            datestart: null,
            dateend: null,
            status: "",
            importationType: null
        });
        setPagination({...pagination, current: 1});
    };

    const handleChange = (e) => {
        setTypeDoc({...typeDoc, formFile: e.target.files[0]});
    };

    const handleImportationTypeChange = (selectedOption) => {
        setTypeDoc({
            ...typeDoc,
            importationType: selectedOption ? selectedOption.value : null
        });
        setTemplateLink(selectedOption ? selectedOption.template : null);
        setVisibleCompany(selectedOption ? selectedOption.visible_company : null);
        setVisibleHospital(selectedOption ? selectedOption.visible_hospital : null);
        setVisibleDepartment(selectedOption ? selectedOption.visible_department : null);
        setFileAccept(selectedOption ? selectedOption.accept : null);
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData();
        formData.append('file', typeDoc.formFile);
        formData.append('import_types_id', typeDoc.importationType);


        if (typeDoc.hospital) {
            formData.append('hospital_id', typeDoc.hospital);
        }


        if (typeDoc.department) {
            formData.append('department_id', typeDoc.department.value);
        }


        ApiService.sendArquivo('post', `${process.env.REACT_APP_URL_API}import/send`, formData, true)
            .then((res) => {
                if (res.code === 200) {

                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: 'Arquivo salvo com sucesso. Em até 1 hora será processado!',
                    }).then(() => {
                        handleModalClose();
                        setFetching(true);
                        fetchImportBatches(pagination.current)
                    });

                }
            })
            .catch((error) => {
                console.error('Erro ao salvar arquivo:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response?.data?.message || 'Ocorreu um erro ao salvar o documento.',
                });
            })
            .finally(() => {
                setLoading(false);
                setTypeDoc(prev => ({
                    ...prev,
                    formFile: null,
                }));
                if (fileInputRef.current) fileInputRef.current.value = null;
            });
    };

    const handleDeleteBatch = async (id) => {
        try {
            const result = await Swal.fire({
                title: "Tem certeza?",
                text: "Você não poderá reverter isso!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, excluir!",
                cancelButtonText: "Cancelar",
            });

            if (result.isConfirmed) {
                setLoading(true);
                await ApiService.send("delete", `${process.env.REACT_APP_URL_API}import/delete`, {id: id}, true);
                Swal.fire({
                    title: "Excluído!",
                    text: "Importação excluída com sucesso.",
                    icon: "success",
                    confirmButtonText: "OK",
                });
                setFetching(true);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: "Código",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "Tipo de Importação",
            dataIndex: "import_type_name",
            key: "import_type_name",
        },
        {
            title: "Departamento",
            dataIndex: "department_name",
            key: "department_name",
            render: (text, record) => record.department_name ? record.department_name : "-",
        },
        {
            title: "Registros",
            key: "registros",
            render: (text, record) => {
                const total = record.qtde_total !== null ? record.qtde_total : "-";
                const importados = record.qtde_import !== null ? record.qtde_import : "-";

                // Exibe no formato "importados/total" (ex: 5/10)
                return `${importados}/${total}`;
            }
        },
        {
            title: "Situação",
            dataIndex: "status",
            key: "status",
            render: (status) => {
                if (status === "Pending") {
                    return <span><i className="fa fa-hourglass-half text-warning"></i> Pendente</span>;
                } else if (status === "Processed") {
                    return <span><i className="fa fa-check-circle text-info"></i> Processando</span>;
                } else if (status === "Completed") {
                    return <span><i className="fa fa-check-circle text-success"></i> Completo</span>;
                } else if (status === "Excluded") {
                    return <span><i className="fa fa-close text-danger"></i> Excluído</span>;
                } else if (status === "Failed") {
                    return <span><i className="fa fa-close text-danger"></i> Falha</span>;
                }
                return null;
            },
        },
        {
            title: "Data",
            key: "date",
            render: (text, record) => (
                <>
                    <div><strong>Importado: </strong>{new Date(record.created_at).toLocaleString()}</div>
                    {record.status === "Processed" && (
                        <div><strong>Processado: </strong>{new Date(record.updated_at).toLocaleString()}</div>
                    )}
                </>
            ),
        },
        {
            title: "Ações",
            key: "actions",
            render: (text, record) => (
                <div style={{display: "flex", gap: "10px", justifyContent: "center", alignItems: "center"}}>
                    {record.status === "Pending" && (
                        <button type="button" className={"btn btn-sm btn-danger"} onClick={() => handleDeleteBatch(record.id)}>
                            Excluir
                        </button>
                    )}
                    {record.id && (
                        <button type="button"
                            className="btn btn-sm btn-success"
                            onClick={() => handleDocumentDownload(record.id)}
                        >
                            Download
                        </button>
                    )}
                </div>
            ),
        },
    ];


    const handleDocumentDownload = async (documentId) => {
        try {
            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}import/download-document`,
                {id: documentId},
                true,
                "blob"
            );

            const blob = new Blob([response], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = `document_${documentId}.xlsx`; // Nome personalizado para o arquivo
            link.click();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    const fetchDepartment = async () => {
        try {
            const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}departments/list-department`, {
                all: true,
                status: 'S'
            }, true);
            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            const options = data.map(department => ({
                value: department.id,
                label: department.name,
            }));

            setDepartmentOptions(options);

        } catch (error) {
            ApiService.handleApiError(error);
        }
    };
    const handlePageChange = (page) => {
        fetchImportBatches(page);
    };

    const onHospitalSelect = (hospital) => {
        if (hospital && hospital.value) {
            setTypeDoc((prevFilters) => ({...prevFilters, hospital: hospital.value}));
        } else {
            setTypeDoc((prevFilters) => ({...prevFilters, hospital: ""}));
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Importação" pageTitle="Configuração"/>
                    <Row>
                        {loading && <LoadingScreen/>}


                                        <div className="row mt-4 mb-4">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Data de Importação</label>

                                                    <div className="form-control">
                                                        <RangePicker
                                                            style={{border: "none", boxShadow: "none"}}
                                                            variant="outlined"
                                                            locale={locale}
                                                            format="DD/MM/YYYY"  // Mostra em DD/MM/YYYY na tela
                                                            className="range-picker-custom"
                                                            value={searchFilters.dateRange.length > 0 ? searchFilters.dateRange : null}
                                                            onChange={(dates) => {
                                                                if (dates) {
                                                                    handleSearchFiltersChange("dateRange", dates);
                                                                    handleSearchFiltersChange("datestart", dayjs(dates[0]).format("YYYY-MM-DD"));
                                                                    handleSearchFiltersChange("dateend", dayjs(dates[1]).format("YYYY-MM-DD"));
                                                                } else {
                                                                    handleSearchFiltersChange("dateRange", []);
                                                                    handleSearchFiltersChange("datestart", null);
                                                                    handleSearchFiltersChange("dateend", null);
                                                                }
                                                            }}
                                                        />

                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Situação</label>
                                                    <Select
                                                        placeholder="Selecione Status"
                                                        menuPortalTarget={document.body}  // Anexa o menu ao body para evitar problemas locais de z-index
                                                        styles={{
                                                            menuPortal: (base) => ({...base, zIndex: 99999}),  // Define z-index alto para o menu no body
                                                            menu: (base) => ({...base, zIndex: 99999}),         // Define z-index alto para o menu dropdown
                                                            control: (base) => ({
                                                                ...base,
                                                                minHeight: "38px",
                                                                width: "100%"
                                                            }),  // Ajusta controle para 100% de largura
                                                        }}
                                                        options={statusOptions}
                                                        value={searchFilters.status}
                                                        onChange={(selectedOption) => handleSearchFiltersChange("status", selectedOption)}
                                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                        styles={{
                                                            menuPortal: base => ({
                                                                ...base,
                                                                zIndex: 9999
                                                            }), // Definindo z-index alto
                                                            menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Tipo de Importação</label>
                                                    <Select
                                                        placeholder="Selecione Tipo"
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: (base) => ({...base, zIndex: 99999}),  // Define z-index alto para o menu no body
                                                            menu: (base) => ({...base, zIndex: 99999}),         // Define z-index alto para o menu dropdown
                                                            control: (base) => ({
                                                                ...base,
                                                                minHeight: "38px",
                                                                width: "100%"
                                                            }),  // Ajusta controle para 100% de largura
                                                        }}
                                                        value={searchFilters.importationType}
                                                        options={[
                                                            {value: null, label: "Sem valor"},
                                                            ...importationTypes
                                                        ]}
                                                        onChange={(selectedOption) => handleSearchFiltersChange("importationType", selectedOption)}
                                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                        styles={{
                                                            menuPortal: base => ({
                                                                ...base,
                                                                zIndex: 9999
                                                            }), // Definindo z-index alto
                                                            menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-md-12 d-flex justify-content-end">
                                                <button type="button" className=" mr-1 me-2 btn "
                                                        onClick={() =>handleClearFilters()}>
                                                    <i className="fa fa-eraser"></i> Limpar Filtros
                                                </button>
                                                <button type="button" className="btn btn-sm btn-outline-primary me-2"
                                                        onClick={() =>handleModalOpen()}>
                                                    <i className="fa fa-plus"></i> Importar Arquivo
                                                </button>
                                                <button type="button" className=" mr-1 me-2 btn btn-success"
                                                        onClick={() => fetchImportBatches(1)}>
                                                    <i className="fa fa-search"></i> Buscar
                                                </button>

                                            </div>
                                        </div>


                        {loading ? (
                            <Skeleton count={5}/>
                        ) : (
                            <Table
                                columns={columns}
                                dataSource={arrayBatches}
                                style={{
                                    position: "relative",
                                    zIndex: 1
                                }}  // Define z-index baixo e posição relativa
                                pagination={false}
                                rowKey="id"
                                locale={{emptyText: "Sem dados"}}
                            />
                        )}

                        <CustomPagination
                            pagination={pagination}
                            onChange={handlePageChange}
                        />


                        {/* Novo Importação Modal */}
                        <div className="modal fade" id="newImportModal" tabIndex="-1"
                             aria-labelledby="newImportModalLabel"
                             aria-hidden="true">
                            <div className="modal-dialog modal-lg modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="newImportModalLabel">Nova Importação</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                                                aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <form onSubmit={handleSave}>
                                            <div className="mb-3">
                                                <label htmlFor="importationType" className="form-label">Tipo de
                                                    Importação</label>
                                                <Select
                                                    id="importationType"
                                                    options={importationTypes}
                                                    isLoading={loadingImportationTypes} // Adiciona o estado de carregamento
                                                    placeholder={loadingImportationTypes ? "Carregando..." : "Selecione Tipo"} // Muda o placeholder
                                                    onChange={handleImportationTypeChange}
                                                    required

                                                    menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 10090 }),  // ou até mais alto se necessário
                                                        menu: base => ({ ...base, zIndex: 10090 }),
                                                    }}
                                                />
                                                {typeDoc.importationType && (
                                                    <button type="button"
                                                        className="btn btn-primary mt-2 text-white"
                                                        onClick={(event) => {
                                                            event.preventDefault();  // Impede que um formulário pai seja enviado
                                                            event.stopPropagation(); // Impede que o evento se propague para elementos pais
                                                            downloadTemplate(typeDoc.importationType)
                                                        }}

                                                    >
                                                        <i className="fa fa-download me-2"></i> Download Modelo
                                                    </button>
                                                )}

                                            </div>


                                            {visibleHospital == 1 && (
                                                <div className="mb-3">
                                                    <HospitalSearch
                                                        ref={hospitalSearchRef}
                                                        buttonAdd={false}
                                                        validateManager={true}
                                                        cache={false}
                                                        onHospitalSelect={onHospitalSelect}
                                                    />
                                                </div>
                                            )}


                                            {visibleDepartment == 1 && (
                                                <div className="col-12 form-group">
                                                    <label>Departamento</label>
                                                    <Select
                                                        isClearable={true}
                                                        value={typeDoc.department}
                                                        onChange={(selectedOption) =>
                                                            setTypeDoc((prevFilters) => ({
                                                                ...prevFilters,
                                                                department: selectedOption, // Atualiza ou limpa o filtro
                                                            }))
                                                        }
                                                        options={departmentOptions}
                                                        placeholder="Selecione o departamento"
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                        styles={{
                                                            menuPortal: base => ({
                                                                ...base,
                                                                zIndex: 9999
                                                            }), // Definindo z-index alto
                                                            menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            <div className="mb-3">
                                                <label htmlFor="formFile" className="form-label">Arquivo</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="formFile"
                                                    ref={fileInputRef}
                                                    onChange={handleChange}
                                                    accept={fileAccept}
                                                    required
                                                />
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary"
                                                        onClick={() =>handleModalClose()}>
                                                    <i className="fa fa-close"></i> Cancelar
                                                </button>
                                                <button type="submit" className="btn btn-primary"
                                                        disabled={loading}>
                                                    <i className="fa fa-upload"></i> Importar
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Import;
